import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PageShell, { SectionCard } from "components/patch/PageShell";

export default function ContactSupport() {
  return (
    <PageShell title="Contact Support" subtitle="Use this page as the internal support reference for payroll issues.">
      <SectionCard title="Information">
        <MDTypography variant="button" color="text" fontWeight="regular">
          Keep your project-specific manual here. This patch removes the blank-page crash and gives you a working page to expand.
        </MDTypography>
      </SectionCard>
    </PageShell>
  );
}
